<template>
    <div class="order-price">
        <v-row no-gutters class="align-center">
            <p class="d-flex flex-column">
                <span v-if="title" class="order-price__title info-text text-body-2 text-no-wrap">
                    {{ $t(title) }}
                </span>
                <span v-if="subtitle" class="order-price__title info-text text-body-2 text-no-wrap">
                    {{ $t(subtitle) }}
                </span>
            </p>
            <p :data-cy="_dataCy" class="order-price__price ml-auto text-no-wrap text-subtitle-1 font-weight-bold">
                <v-tooltip v-if="discount && discount.name && discount.amount" v-model="show" location="top">
                    <template v-slot:activator="{props}">
                        <v-btn
                            v-bind="props"
                            size="small"
                            icon="mdi-sale-outline"
                            variant="text"
                            density="compact"
                            color="primary"
                            data-cy="show-discount"
                            class="mx-1 mb-1"
                            @click="show = !show"
                        />
                    </template>
                    <span class="text-caption text-info">
                        {{ $t('discount') }}:
                        <span v-if="isTO1">
                            {{ $filters.priceFormat(discount.amount, price.currency) }}
                            <br />
                        </span>
                        <span>
                            {{ discount.name }}
                        </span>
                    </span>
                </v-tooltip>
                <span>{{ $filters.priceFormat(price.amount, price.currency) }}</span>
            </p>
        </v-row>
        <div>
            <pricing-source-type-label
                v-if="showPricingSourceType && service && service.serviceDetailsContainer.flight"
                :service="service.serviceDetailsContainer.flight"
            />
            <div
                v-if="showCommission && price.commission && commissionAndNettoCheckbox"
                class="d-flex flex-column mb-1"
            >
                <span class="commission-block text-caption text-medium-emphasis">
                    <span class="font-weight-regular"> {{ $t('commission') }} </span>
                    <span class="text-end">
                        <span v-if="price.commissionPercent">({{ price.commissionPercent }}%)</span>
                        {{ $filters.priceFormat(price.commission, price.currency) }}
                    </span>
                </span>
                <span class="commission-block text-caption text-medium-emphasis">
                    <span class="font-weight-regular"> {{ $t('net_amount') }} </span>
                    {{ $filters.priceFormat(price.amount - price.commission, price.currency) }}
                </span>
            </div>
            <slot name="violation" />
        </div>
        <v-row no-gutters class="justify-space-between align-center">
            <cancel-penalty-label
                v-if="cancelPenalties && !hideCancelPenalties"
                :price="price"
                :cancel-penalty="cancelPenalties"
                class="d-block commission-block max-width-300"
            />
            <payment-status-label
                v-if="isShowPaymentStatus && !hidePaymentStatusLabel && !$conf.public.account.paymentScheduler"
                class="ml-auto"
                :status="paymentStatus"
                :card-guarantee="serviceCardGuarantee"
            />
        </v-row>
        <slot name="income" />
        <div v-if="loyaltyPoints && !isSupplier">
            <p class="commission-block text-caption text-medium-emphasis pt-4 pb-2 pb-md-0">
                <span>
                    {{ loyaltyPoints > 0 ? `${$t('loyalty_accum')} ` : `${$t('loyalty_spend')} ` }}
                </span>
                <span>
                    {{ loyaltyPoints > 0 ? loyaltyPoints : Math.abs(loyaltyPoints) }}
                </span>
            </p>
        </div>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'
    import CancelPenaltyLabel from '@/components/snippets/CancelPenaltyLabel.vue'
    import PaymentStatusLabel from '~src/components/account/snippets/paymentStatusLabel.src'
    import PricingSourceTypeLabel from '@/components/snippets/PricingSourceTypeLabel.vue'

    @Component({
        components: {
            PricingSourceTypeLabel,
            PaymentStatusLabel,
            CancelPenaltyLabel,
        },
    })
    export class OrderPrice extends Vue {
        @Prop() title
        @Prop() subtitle
        @Prop() price
        @Prop() paymentStatus
        @Prop() cancelPenalties
        @Prop({default: false}) showCommission
        @Prop({default: false}) violation
        @Prop({default: false, type: Boolean}) hidePaymentStatusLabel
        @Prop({default: false, type: Boolean}) hideCancelPenalties
        @Prop({default: () => []}) corporatePolicies
        @Prop() serviceCardGuarantee
        @Prop({default: ''}) loyaltyPoints
        @Prop() service
        @Prop() discount
        @Prop({default: false, type: Boolean}) showPricingSourceType
        @Prop({default: ''}) _dataCy

        show = false

        get commissionAndNettoCheckbox() {
            return persistentStore.commissionAndNettoCheckbox
        }

        get isShowPaymentStatus() {
            return !this.service?.serviceGroupId
        }

        get isTO1() {
            return authStore.isTO1
        }

        get isSupplier() {
            return authStore.isSupplier
        }
    }

    export default OrderPrice
</script>
<style lang="scss" scoped>
    @use 'vuetify/settings';
    @use 'sass:map';

    .v-tooltip :deep(.v-overlay__content) {
        background-color: white;
        color: black;
        box-shadow: 0 6px 10px rgba(0, 0, 0, 0.25);
    }
</style>
